import { useContext } from "react";
import WizardContext from "./WizardContext";

/**
 * useWizardPage - Helper hook for wizard pages to access wizard context and helpers
 *
 * Usage in a page:
 *   const { inputManifest, emittedManifest, updateEmittedManifest } = useWizardPage();
 *   const [name, setName] = useSyncedField('name', '');  // Import useSyncedField separately
 *   const [email, setEmail] = useSyncedField('email', '');
 */
const useWizardPage = () => {
    const context = useContext(WizardContext);

    const updateEmittedManifest = (updates) => {
        const newManifest = { ...context.emittedManifest, ...updates };
        context.setEmittedManifest(newManifest);
    };

    const updateRuntimeVariables = (updates) => {
        const newVariables = { ...context.runtimeVariables, ...updates };
        context.setRuntimeVariables(newVariables);
    };

    return {
        inputManifest: context.inputManifest,
        emittedManifest: context.emittedManifest,
        updateEmittedManifest,
        runtimeVariables: context.runtimeVariables,
        updateRuntimeVariables,
        context,
        setEmittedManifest: context.setEmittedManifest,
        setRuntimeVariables: context.setRuntimeVariables,
    };
};

export default useWizardPage;
